import styled from 'styled-components';

export const MapStyles = styled.div`
  #map-wrap {
    position: relative;
    width: 100%;
    max-width: 960px;
    margin: 0 auto;
    height: 600px;
    border: 1px solid #ebeaea;
  }

  @media (max-width: 500px) {
    #map-wrap {
      height: 150vw;
      min-height: 00px;
    }
  }

  .mapContainer {
    width: 100%;
    height: 100%;
  }

  .MuiButton-root {
    margin: 0 !important;
  }

  // tool tip styles
  .toolt-wrap {
    position: relative;
    padding: 14px;
    // width: 260px;
  }

  .toolt-place {
    font-family: 'Raleway';
    font-size: 16px;
    font-weight: 900;
  }

  .toolt-state {
    font-family: 'Ubuntu';
    font-size: 10px;
    font-weight: 400;
    text-transform: uppercase;
    margin-bottom: 10px;
    padding-bottom: 5px;
    width: 100%;
    border-bottom: 1px solid #dfdfdf;
  }

  .toolt-pop {
    font-size: 12px;
    font-family: 'Ubuntu', sans-serif;
    font-weight: 700;
    padding-bottom: 4px;
    color: #777;
  }

  .toolt-seperator {
    width: 100%;
    height: 1px;
    border-bottom: 1px solid #dfdfdf;
    margin: 10px 0;
  }

  .emph {
    font-size: 21px;
    line-height: 23px;
    margin-left: 6px;
  }

  //svg
  svg {
    font-weight: 300;
    font-size: 8px;
    font-family: 'Raleway', sans-serif;
  }

  .x-axis,
  .y-axis {
    pointer-events: none;
  }

  .x-axis .domain,
  .axis--x .domain {
    opacity: 0;
  }

  .x-axis line,
  .y-axis line,
  .extra-axis {
    stroke: #999;
    opacity: 0.5;
  }

  .y-axis .tick text,
  .x-axis .tick text {
    fill: #777;
    font-family: 'Raleway';
    font-size: 11px;
  }
`;
